import React from 'react';


export function Footer() {
  return (
    <footer className="bg-gray-100 py-8">
      <div className="container mx-auto px-6 text-center text-sm text-gray-500">
        © {new Date().getFullYear()} Farrell CPA, PLLC. All rights reserved.
      </div>
    </footer>
  );
}
